import { API_AUTH_CHOTT,API_AUTH } from "../common";

const danhSachThongTinVayApi = {
  getTinhThanhByLevel: ( iLevel ) =>
  API_AUTH_CHOTT.get(
      `ThongTinAPI/GetTinhThanhByLevel?iLevel=${iLevel}`,
      {}
    ),
    getTinhThanhByIdParent: ( idParent ) =>
    API_AUTH_CHOTT.get(
        `ThongTinAPI/GetTinhThanhByIdParent?idParent=${idParent}`,
        {}
      ),
      danhSachDangKyVay: ( data ) =>
        API_AUTH_CHOTT.get(
            `ThongTinAPI/DanhSachDangKyVay?IdTinh=${data.IdTinh}&IdHuyen=${data.IdHuyen}&IdXa=${data.IdTinh}&sHoVaTen=${data.sHoVaTen}&sTrangThai=${data.sTrangThai}&iPageIndex=${data.iPageIndex}&iPageSize=${data.iPageSize}`,
            {}
          ),
      danhSachDaMua: ( data ) =>
        API_AUTH_CHOTT.get(
            `ThongTinAPI/DanhSachDaMua?IdTinh=${data.IdTinh}&IdHuyen=${data.IdHuyen}&IdXa=${data.IdTinh}&sHoVaTen=${data.sHoVaTen}&IdCuaHang=${data.IdCuaHang}&iPageIndex=${data.iPageIndex}&iPageSize=${data.iPageSize}`,
            {}
          ),
      muaThongTin: ( data ) =>
        API_AUTH_CHOTT.post(
          `ThongTinAPI/MuaThongTin`,
          data
        ),
        checkRoleChoTinDung: () =>
        API_AUTH.get(`danh-sach-thong-tin/checkRoleChoTinDung`, {}),
};
export default danhSachThongTinVayApi;
